import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { getInternalStatus } from '~/common';

const Component = ({statuses, selectedStatus, onContextMenu}) => {
    const getClassName = (status) => {
        let className = 'context-menu';
        if (selectedStatus && status.code === selectedStatus.code) {
            className += ' selected';
        }
        return className;
    };

    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell className="code">Код</TableCell>
                    <TableCell className="status">Статус</TableCell>
                    <TableCell className="status_internal">Внутренний статус</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {statuses.map((status) => (
                        <TableRow key={status.id} className={getClassName(status)}
                                  onContextMenu={onContextMenu(status)}
                        >
                            <TableCell className="code">{status.code}</TableCell>
                            <TableCell className="status">
                                <Typography noWrap={true}>{status.status}</Typography>
                            </TableCell>
                            <TableCell className="status_internal">
                                {getInternalStatus(status.internal)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    statuses: PropTypes.array.isRequired,
    selectedStatus: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
